export class KafkaSchemaOverridesConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "fieldOverrides",
            "baseName": "fieldOverrides",
            "type": "Array<FieldOverride>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaSchemaOverridesConfig.attributeTypeMap;
    }
    constructor() {
    }
}
